var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfesionaless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49983 14.8743C14.0898 14.8743 17.8766 18.31 18.4301 22.7493H0.56958C1.12308 18.31 4.90983 14.8743 9.49983 14.8743ZM7.46021 17.4393C5.84696 17.95 4.48908 19.0514 3.64983 20.4993H9.49983L7.46021 17.4393ZM11.5406 17.4393L9.49983 20.4993H15.3487C14.5106 19.0514 13.1527 17.95 11.5406 17.4393ZM16.2498 0.249268V6.99927C16.2498 10.7275 13.2281 13.7493 9.49983 13.7493C5.77158 13.7493 2.74983 10.7275 2.74983 6.99927V0.249268H16.2498ZM4.99983 6.99927C4.99983 9.48552 7.01358 11.4993 9.49983 11.4993C11.9861 11.4993 13.9998 9.48552 13.9998 6.99927H4.99983ZM13.9998 2.49927H4.99983V4.74927H13.9998V2.49927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfesionaless);
export default __webpack_public_path__ + "static/media/profesionaless.0d6db052bde49f3b8333d5bec9d1fdb3.svg";
export { ForwardRef as ReactComponent };